export function getSafeRedirectPath(
  redirect: string | null | undefined,
  origin: string
) {
  if (!redirect?.startsWith('/')) {
    return null;
  }

  try {
    const url = new URL(redirect, origin);
    const path = url.pathname + url.search + url.hash;

    if (url.origin !== origin || path.startsWith('//')) {
      return null;
    }

    return path;
  } catch {
    return null;
  }
}
